/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedShippingInfoLink_viewer$ref = any;
export type PdpSharedDetailShipping_viewer$ref = any;
export type PdpSharedDetailShipping_viewer = {
    readonly relevantShipping?: {
        readonly quoteRequestStatus: string | null;
    } | null;
    readonly " $fragmentRefs": PdpSharedShippingInfoLink_viewer$ref;
    readonly " $refType": PdpSharedDetailShipping_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedDetailShipping_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "itemId",
            "type": "String!"
        },
        {
            "kind": "RootArgument",
            "name": "userId",
            "type": "String"
        },
        {
            "kind": "RootArgument",
            "name": "fetchUser",
            "type": "Boolean"
        }
    ],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingInfoLink_viewer",
            "args": null
        },
        {
            "kind": "Condition",
            "passingValue": true,
            "condition": "fetchUser",
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "relevantShipping",
                    "storageKey": null,
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "buyerId",
                            "variableName": "userId"
                        },
                        {
                            "kind": "Variable",
                            "name": "itemId",
                            "variableName": "itemId"
                        }
                    ],
                    "concreteType": "RelevantShippingInfo",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "quoteRequestStatus",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = '30dc1182b3e22ccb317d44132abfb6ee';
export default node;
